import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetFundingDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_FUNDING_DETAILS, token);
  return res;
};

export const AddFunding = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_FUNDING, payload, token);
  return res;
};

export const UpdateFunding = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_FUNDING + payload.id, payload, token);
  return res;
};

export const DeleteFunding = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_FUNDING + id, id, token);
  return res;
};
